import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import screens from '../../screens';
import QueueService from '../../services/QueueService';
import { setModal } from '../../state/actions/modal';
import store from '../../state/store';
import parseQueryString from './parseQueryString';
import updateURL from './updateURL';
var EventEmitter = require('events');
var queryParamProxy = /*#__PURE__*/function (_EventEmitter) {
  function queryParamProxy() {
    var _this;
    _classCallCheck(this, queryParamProxy);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, queryParamProxy, [].concat(args));
    /** Hold the query params */
    _this.query = undefined;
    _this.QUERY_PARAM_CHANGE = 'ROUTE_PARAM_CHANGE';
    _this.ROUTE_CHANGE = 'ROUTE_CHANGE';
    _this.m_modalPromise = undefined;
    _this.m_modalPromiseAccept = undefined;
    _this.paramQueue = new QueueService();
    _this.lastParams = undefined;
    /**
     * Call this method on page load to read query string into memory and initialize modalPromise
     */
    _this.init = function () {
      if (_this.query === undefined) {
        _this.query = parseQueryString();
      }
    };
    _this.updateURL = updateURL;
    _this.enqueueScreens = [screens.DynamicPopups, screens.DailySpin, screens.DailySpinOnboarding, screens.WelcomeBonus, screens.News, screens.LimitedTimeOffer];
    /**
     *
     * @param {Object} params Param object
     */
    _this.setQueryParams = function (params) {
      var _this$lastParams, _this$lastParams2, _this$lastParams3;
      var isParamsValid = ((_this$lastParams = _this.lastParams) === null || _this$lastParams === void 0 ? void 0 : _this$lastParams.m) !== undefined && !((_this$lastParams2 = _this.lastParams) !== null && _this$lastParams2 !== void 0 && _this$lastParams2.deep_link_trigger) && params.m !== undefined && ((_this$lastParams3 = _this.lastParams) === null || _this$lastParams3 === void 0 ? void 0 : _this$lastParams3.m) !== params.m && _this.enqueueScreens.includes(params.m);
      if (isParamsValid) {
        _this.paramQueue.enqueue(params);
        return;
      }
      _this.processParams(params);
    };
    _this.processParams = function (params) {
      if (!params.skip_set_modal) {
        store.dispatch(setModal(params.m));
        _this.lastParams = params;
      }
      _this.query = _objectSpread(_objectSpread({}, _this.query), params);
      delete _this.query.skip_set_modal;
      delete _this.query.deep_link_trigger;
      for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value === undefined || value === null) {
          delete _this.query[key];
        }
      }
      _this.updateURL(_this.query);
      _this.emit(_this.QUERY_PARAM_CHANGE, params);
      if (!_this.paramQueue.isEmpty()) {
        var queuedParams = _this.paramQueue.dequeue();
        _this.processParams(queuedParams);
      }
    };
    /**
     * Special version of setQueryParams that returns a promise that resolves when the modal closes.
     * @param {Object} params Param object
     * @param {String} params.m Screen to be displayed as modal
     * @returns {Promise} Promise that will resolve when modal closes
     */
    _this.setQueryParamsWithModalPromise = function (params) {
      _this.m_modalPromise = new Promise(function (resolve) {
        return _this.m_modalPromiseAccept = resolve;
      });
      _this.setQueryParams(params);
      return _this.m_modalPromise;
    };
    // Navigate using this to fix the url automatically.
    // We basically no longer care what React Navigation thinks the query string is, because it's usually wrong.
    _this.navigate = function (navigation, to, params) {
      if (params instanceof Object) {
        _this.setQueryParams(params);
      }
      navigation.navigate(to, params);
      _this.updateURL(_this.query);
      _this.emit(_this.ROUTE_CHANGE);
    };
    /**
     * Utility to find a param.
     * @param {*} navigation
     * @param {String} get
     * @param {*} missingVal
     */
    _this.findParam = function (get, missingVal) {
      if (_this.query === undefined) return missingVal;
      return _this.query[get] || missingVal;
    };
    _this.getAllParams = function () {
      if (_this.query === undefined) return null;
      return _this.query;
    };
    _this.dismissModal = function () {
      _this.setQueryParams(_defineProperty({}, 'm', undefined));
    };
    return _this;
  }
  _inherits(queryParamProxy, _EventEmitter);
  return _createClass(queryParamProxy, [{
    key: "modalPromiseAccept",
    get: function get() {
      // Enforce single use nature of the accept.
      if (typeof this.m_modalPromiseAccept === 'function') {
        var accept = this.m_modalPromiseAccept;
        this.m_modalPromiseAccept = undefined;
        return accept;
      }
      // If it's undefined, return a no-op to the caller
      return function () {};
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(obj) {
      for (var key in obj) {
        if (!obj.hasOwnProperty) return false;
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    }
  }]);
}(EventEmitter);
var QueryParamProxy = new queryParamProxy();
export default QueryParamProxy;